import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    table(opt, tar) {
      return $(`
      <table class="el-table__header" cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          <col name="" key="">
          <col name="gutter">
        </colgroup>
        <thead class="is-group has-gutter">
          <tr>
            <th>
              <div class="cell">
                <span class="caret-wrapper">
                  <i class="sort-caret ascending">
                  </i>
                  <i class="sort-caret descending">
                  </i>
                </span>
                <span class="el-table__column-filter-trigger">
                  <i class="el-icon-arrow-down el-icon-arrow-up"></i>
                </span>
              </div>
            </th>
            <th class="gutter"></th>
          </tr>
        </thead>
      </table>`)
    },
  },
  updater: {
    fit(value, opt, tar, node) {},
    stripe(value, opt, tar, node) {},
    border(value, opt, tar, node) {},
    isGroup(value, opt, tar, node) {},
    isHidden(value, opt, tar, node) {},
    maxHeight(value, opt, tar, node) {},
    showHeader(value, opt, tar, node) {},
  },
}

export default class Table extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      fit: false, // 禁用
      stripe: false, // 禁用
      border: false, // 禁用
      isGroup: false, // 禁用
      isHidden: false, // 禁用
      maxHeight: false, // 禁用
      showHeader: false, // 禁用
    }
    this.events = {
      reset: null,
    }
    this.settings = Object.assign({}, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.table(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {}

  currentChange() {}

  trimFinal() {}

  set data(value) {
    this.settings.data = value
  }

  get data() {
    return this.settings.data
  }
}
